import { useEffect, useState } from "react";
import { fetchTeamSelectOptions } from "../clubSelectApi";
import type { ProgramGameSelectOption } from "../types";

export function useProgramGameTeamOptions(
	isOpen: boolean,
	clubId: number | null,
): { teamOptions: ProgramGameSelectOption[]; teamsLoading: boolean } {
	const [teamOptions, setTeamOptions] = useState<ProgramGameSelectOption[]>([]);
	const [teamsLoading, setTeamsLoading] = useState(false);

	useEffect(() => {
		if (!isOpen) {
			setTeamOptions([]);
			setTeamsLoading(false);
			return;
		}
		if (clubId === null || Number.isNaN(clubId)) {
			setTeamOptions([]);
			setTeamsLoading(false);
			return;
		}
		let cancelled = false;
		setTeamsLoading(true);
		void fetchTeamSelectOptions(clubId)
			.then((options) => {
				if (!cancelled) {
					setTeamOptions(options);
				}
			})
			.catch(() => {
				if (!cancelled) {
					setTeamOptions([]);
				}
			})
			.finally(() => {
				if (!cancelled) {
					setTeamsLoading(false);
				}
			});
		return () => {
			cancelled = true;
		};
	}, [isOpen, clubId]);

	return { teamOptions, teamsLoading };
}
